import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-[#0F0F1A] relative overflow-hidden" data-id="element-175">
      <div className="container mx-auto px-4" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <h2 className="text-3xl md:text-5xl font-bold font-display mb-4" data-id="element-178">
            Why settle for{' '}
            <span className="text-gray-500 line-through decoration-red-500" data-id="element-179">
              default
            </span>
            ?
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-180">
            Most gamers spend thousands of hours online with an avatar that
            looks exactly like everyone else's. It's time for an upgrade.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-181">
          {/* The Problem Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-900/5 border border-red-500/10 rounded-3xl p-8 md:p-12 relative overflow-hidden group" data-id="element-182">
            <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-183">
              <XCircle className="w-32 h-32 text-red-500" data-id="element-184" />
            </div>
            <h3 className="text-2xl font-bold text-red-400 mb-6 flex items-center gap-2" data-id="element-185">
              <XCircle className="w-6 h-6" data-id="element-186" /> The Generic Trap
            </h3>
            <ul className="space-y-4" data-id="element-187">
              {['Avatars that look like everyone else', 'Limited customization options in-game', 'No way to express unique personality', 'Inconsistent identity across platforms'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-400" data-id="element-188">
                  <span className="w-1.5 h-1.5 rounded-full bg-red-500/50 mt-2.5" data-id="element-189" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* The Solution Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-green-900/5 border border-green-500/10 rounded-3xl p-8 md:p-12 relative overflow-hidden group" data-id="element-190">
            <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-191">
              <CheckCircle2 className="w-32 h-32 text-green-500" data-id="element-192" />
            </div>
            <h3 className="text-2xl font-bold text-green-400 mb-6 flex items-center gap-2" data-id="element-193">
              <CheckCircle2 className="w-6 h-6" data-id="element-194" /> The Avatarise Way
            </h3>
            <ul className="space-y-4" data-id="element-195">
              {['Unique, hand-crafted avatar designs', 'Unlimited customization possibilities', 'Consistent identity everywhere you play', 'Express your true gaming personality'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-196">
                  <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0" data-id="element-197" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}